import { AppConfig } from '@aipb/gulliver/env/util';
import { ZipManagerEnv } from './zip-manager.env';

export class ZipManagerConfig extends AppConfig<ZipManagerEnv> {}
